<template>
  <div>
    <!-- 速度警告 (PCではない場合のみ表示) -->
    <v-dialog
      v-if="isMonitoringEnabled"
      v-model="showAlert"
      persistent
      max-width="400"
      class="speed-alert-modal"
    >
      <v-card>
        <v-card-title>
          <v-img src="~/assets/images/icons/ic_warning_danger.png" class="icons d-flex justify-center w-100" />
          <h2 class="alert-title">
            警告
          </h2>
        </v-card-title>
        <v-card-text>
          <p class="alert-message">
            {{ alertMessage }}
          </p>
        </v-card-text>
        <v-card-actions v-if="!isGpsError || isSuppressibleGpsError" class="px-5 mt-6">
          <CustomButton @click="geolocationStore.setWarningSuppressed(true)">
            OK
          </CustomButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import CustomButton from '~/components/common/parts/CustomButton.vue';
import { MessageCodeEnum } from '~/constants/MessageCode';

const { getMessage } = useMessage();

// 位置情報ストアから派生ステータスを取得
const geolocationStore = useGeolocationStore();
const {
  isSpeedExceeded,
  isGpsError,
  isSuppressibleGpsError,
  isWarningSuppressed,
} = storeToRefs(geolocationStore);

// 速度警告モーダルの業務的な表示前提条件
const { canShowSpeedAlert } = useSpeedMonitoringConditions();

const showAlert = computed(() => isSpeedExceeded.value || isGpsError.value);

// 警告文言（警告の要因ごとに画面メッセージを切り替える）
const alertMessage = computed(() => {
  if (isGpsError.value) {
    return isSuppressibleGpsError.value
      // 電波状況など環境起因のGPSエラー
      ? getMessage(MessageCodeEnum.LOCATION_UNAVAILABLE_POOR_SIGNAL)
      // GPSがOFF・権限なしなど利用者側の設定に起因するGPSエラー
      : getMessage(MessageCodeEnum.LOCATION_UNAVAILABLE_GPS_OFF);
  }
  // 速度超過
  return getMessage(MessageCodeEnum.SPEED_EXCEEDED);
});

// モーダルをDOMに乗せてよいか（業務前提 + 警告抑制状態）
const isMonitoringEnabled = computed(() => {
  if (!canShowSpeedAlert.value) {
    return false;
  }
  // 警告抑止中はモーダルを出さない
  // （権限なし・端末非対応など環境起因でないGPSエラーは抑止対象外として表示し続ける）
  if (isWarningSuppressed.value && (!isGpsError.value || isSuppressibleGpsError.value)) {
    return false;
  }
  return true;
});
</script>

<style scoped lang="scss">
.speed-alert-modal {
  z-index: 99999 !important;

  .v-card {
    padding: 48px 24px;
    text-align: center;
  }

  .alert-title {
    margin: 0;
    font-size: 48px;
    font-weight: bold; /* フォントの太さ */
    color: #f44336; /* 赤色 */
  }

  .v-card-text {
    padding: 16px !important;
  }

  .alert-message {
    margin: 0;
    font-size: 24px; /* メッセージのフォントサイズ */
    font-weight: bold; /* フォントの太さ */
    color: #f44336; /* 赤色 */
    text-align: left; /* 左寄せ */
  }

  .v-btn {
    min-width: 100px;
  }
}

.icons {
  width: 80px;
  height: 80px;
}
</style>
